import { UserManager } from 'oidc-client-ts';
// import Amplify from 'aws-amplify';
// import { Auth } from 'aws-amplify'

const env =  process.env.NODE_ENV || 'dev';

let redir = 'https://echoslip.io/login';
if (env !== 'dev') redir = 'http://localhost:3000/login'

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-2.amazonaws.com/us-east-2_LZivMlQ7H",
  client_id: "60eoggqrbcv4enqrgjcgchocvg",
  // redirect_uri: "https://d84l1y8p4kdic.cloudfront.net",
  redirect_uri: redir,
  response_type: "code",
  scope: "phone openid email"
};

export const userManager = new UserManager({
  ...cognitoAuthConfig
});

export async function signOutRedirect () {
  const clientId = "60eoggqrbcv4enqrgjcgchocvg";
  const logoutUri = "<logout uri>";
  const cognitoDomain = "https://<user pool domain>";
  window.location.href = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(logoutUri)}`;
}

// Auth.configure({
//   region: 'us-east-2',
//   userPoolId: 'us-east-2_LZivMlQ7H',
//   userPoolWebClientId: '60eoggqrbcv4enqrgjcgchocvg',
//   mandatorySignIn: false,
//   oauth: {
//     // domain: 'https://<user pool domain>',
//     scope: ['email', 'openid', 'profile'],
//     redirectSignIn: redir,
//     redirectSignOut: redir,
//     responseType: 'code',
//   }
// });

// Amplify.configure({
//   Auth: {
//     region: 'us-east-2',
//     userPoolId: 'us-east-2_LZivMlQ7H',
//     userPoolWebClientId: '60eoggqrbcv4enqrgjcgchocvg',
//   },
// });